const deliverySettings = {
  deliveryEnabled: false,
};

export default deliverySettings;
